var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nb-confirm',_vm._g({attrs:{"ghost":"","text":"reset"}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }